import { createFileRoute } from "@tanstack/react-router";

import { RouteErrorFallback } from "@/components/error-message";
import { catalogQueryOptions } from "@/features/cards/lib/catalog-queries";
import {
  metaDeckQueryOptions,
  metaEventPageQueryOptions,
  metaSubmitEventQuery,
} from "@/features/meta/lib/meta-queries";
import { parseMetaSubmitSearch } from "@/features/meta/lib/meta-submit-link";
import { initQueryOptions } from "@/lib/init-queries";
import { seoHead } from "@/lib/seo";
import { getSiteUrl } from "@/lib/site-config";

/** An unknown slug renders the picker; it does not 404. */
export const Route = createFileRoute("/_app/_authenticated/meta_/$slug_/submit")({
  ssr: "data-only",
  head: () => seoHead({ siteUrl: getSiteUrl(), title: "Send a decklist", noIndex: true }),
  validateSearch: parseMetaSubmitSearch,
  loaderDeps: ({ search }) => ({ deck: search.deck }),
  loader: async ({ context, deps, params }) => {
    await Promise.all([
      context.queryClient.query({ ...initQueryOptions, staleTime: "static" }),
      context.queryClient.query({
        ...metaEventPageQueryOptions(metaSubmitEventQuery(params.slug)),
        staleTime: "static",
      }),
      context.queryClient.query({ ...catalogQueryOptions, staleTime: "static" }),
      // Puts the edited list in cache before the form mounts. A token that no
      // longer resolves is not fatal: the box just opens empty.
      deps.deck === undefined
        ? Promise.resolve()
        : context.queryClient
            .query({ ...metaDeckQueryOptions(deps.deck), staleTime: "static" })
            .catch(() => null),
    ]);
  },
  errorComponent: RouteErrorFallback,
});
